import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["src"]

import { computed, ref } from 'vue'
import { deliveryStore } from '@/stores/delivery'
import DeliveryChaptersCard from '@/views/delivery/cards/DeliveryChaptersCard.vue'
import { CheckOutlined, CloseOutlined, BorderOuterOutlined } from '@ant-design/icons-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryRoomsCard',
  setup(__props) {

const showFloorplanModal = ref(false)
const floorplan = ref<string|null>(null)

const allGood = computed(() => {
  const allGood:boolean[] = []

  deliveryStore().delivery.rooms.forEach((r:{ survey_form: { chapters: { questions: { required:boolean, answer: { answer:string|null, issues: { id:number }[] } }[] }[] }}, index:number) => {
    allGood[index] = true
    r.survey_form.chapters.forEach((c) => {
      c.questions.forEach((q) => {
        if (q.answer.answer === 'no') {
          allGood[index] = false
        }
      })
    })
  })

  return allGood
})

function toggleFloorplanModal (directory:string|null = null) : void {
  if (directory) {
    floorplan.value = deliveryStore().delivery?.building?.media?.floorplans[directory]?.url
    showFloorplanModal.value = true
  } else {
    showFloorplanModal.value = false
    floorplan.value = null
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "Ruimtes",
      bordered: false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deliveryStore)().delivery.rooms, (r, roomIndex) => {
          return (_openBlock(), _createBlock(_component_a_collapse, {
            bordered: false,
            key: r.id
          }, {
            expandIcon: _withCtx(() => [
              (_unref(allGood)[roomIndex])
                ? (_openBlock(), _createBlock(_unref(CheckOutlined), {
                    key: 0,
                    style: {"color":"green"}
                  }))
                : (_openBlock(), _createBlock(_unref(CloseOutlined), {
                    key: 1,
                    style: {"color":"red"}
                  }))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_collapse_panel, { style: {"background":"white","border-bottom":"1px solid #e8e8e8"} }, _createSlots({
                header: _withCtx(() => [
                  _createElementVNode("b", null, _toDisplayString(r.level) + "." + _toDisplayString(r.position) + " " + _toDisplayString(r.name), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(r.survey_form.chapters, (c, i) => {
                    return (_openBlock(), _createBlock(DeliveryChaptersCard, {
                      chapter: c,
                      room: r,
                      lastItem: i === r.survey_form.chapters.length - 1,
                      key: c.id
                    }, null, 8, ["chapter", "room", "lastItem"]))
                  }), 128))
                ]),
                _: 2
              }, [
                (_unref(deliveryStore)().delivery.building?.media?.floorplans['floorplanLevel' + r.level])
                  ? {
                      name: "extra",
                      fn: _withCtx(() => [
                        _createVNode(_component_a_tooltip, {
                          title: "Plattegrond bekijken",
                          placement: "left"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(BorderOuterOutlined), {
                              style: { color: '#f38929' },
                              onClick: _withModifiers(($event: any) => (toggleFloorplanModal('floorplanLevel' + r.level)), ["stop"])
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1024)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: "Verdiepingsplattegrond.",
      bodyStyle: { padding: 0 },
      footer: false,
      visible: showFloorplanModal.value,
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (toggleFloorplanModal()))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { class: "no-mb" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: floorplan.value,
                  class: "fw"
                }, null, 8, _hoisted_1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})